/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_SeoInputs */

const cs_blog_seo = /** @type {(inputs: Blog_SeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO`)
};

const en_blog_seo = /** @type {(inputs: Blog_SeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO`)
};

/**
* | output |
* | --- |
* | "SEO" |
*
* @param {Blog_SeoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_seo = /** @type {((inputs?: Blog_SeoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_SeoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_seo(inputs)
	return cs_blog_seo(inputs)
});